/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractFinderGridDefinition } from '@gh/common-internal-shared';
import { TranslationService } from '@gh/core-mls';
import { ColDef } from 'ag-grid-community';
import { getHousePlanId } from '../../resources/house-plan-finder.model';

@Injectable()
export class HousePlanFinderGridDefinition extends AbstractFinderGridDefinition {
  getId = getHousePlanId;

  constructor(private translationService: TranslationService) {
    super();
  }

  buildColumnDefs(): ColDef[] {
    return [
      { field: 'code', headerName: this.translationService.get('lbl_code'), width: 250 },
      { field: 'name', headerName: this.translationService.get('lbl_description'), width: 450 },
    ];
  }

}
